import { GET_ORDER_SHIPPING_GROUPS_INFO } from '../actionTypes/OrderActionTypes';

export const getOrderShippingGroupsInfo = (payload) => ({
    type: GET_ORDER_SHIPPING_GROUPS_INFO,
    payload,
});

export default getOrderShippingGroupsInfo;
